'use strict'

const {
  FIELD_TYPES
} = require('@wix/wix-data-client-common/src/collections/consts')

const supportedAutomationFieldsTypes = [
  FIELD_TYPES.TEXT,
  FIELD_TYPES.RICHTEXT,
  FIELD_TYPES.BOOLEAN,
  FIELD_TYPES.DATETIME,
  FIELD_TYPES.REFERENCE,
  FIELD_TYPES.NUMBER,
  FIELD_TYPES.URL,
  FIELD_TYPES.STRING_ARRAY
]

const isFieldSupported = (fieldData, fieldName) => {
  const supportedSystemFieldsNames = ['_createdDate', '_updatedDate']
  const fieldType = fieldData.type
  const isSupportedType = supportedAutomationFieldsTypes.includes(fieldType)
  const isSystemField = !!fieldData.systemField
  const isSupportedSystemField = supportedSystemFieldsNames.includes(
    fieldName || fieldData.name
  )
  return (!isSystemField || isSupportedSystemField) && isSupportedType
}

module.exports = isFieldSupported
